import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import styles from '../../styles/main.scss';

// components
import { Spinner } from 'dibs-elements/exports/Spinner';
import { Button } from 'dibs-elements/exports/Button';
import classNames from 'classnames';

const messages = defineMessages({
    save: {
        id: 'dc.CreditCard.Submit.save',
        defaultMessage: 'Save',
    },
    saving: {
        id: 'dc.CreditCard.Submit.saving',
        defaultMessage: 'Saving...',
    },
});

const Submit = ({ label, wrapperClass = '', isSaving = false, disabled = false, onClick }) => {
    const intl = useIntl();
    const buttonClasses = classNames({
        [styles.buttonDisabled]: disabled,
        [wrapperClass]: true,
    });
    return (
        <Button
            className={buttonClasses}
            dataTn="submit"
            disabled={isSaving}
            fullWidth
            onClick={onClick}
            size="large"
        >
            {isSaving && <Spinner containerClass={styles.inlineSpinner} />}
            {isSaving
                ? intl.formatMessage(messages.saving)
                : label || intl.formatMessage(messages.save)}
        </Button>
    );
};

Submit.propTypes = {
    label: PropTypes.node,
    wrapperClass: PropTypes.string,
    disabled: PropTypes.bool,
    isSaving: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

export default Submit;
